export default __webpack_public_path__ + "f61b4ae791dbd63362127b671dbe9841.png";